import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    TextField,
    MenuItem
  } from "@mui/material";
  import React, { Dispatch, SetStateAction, useState } from "react";
import { CouponService } from "../../services/CouponService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "./CustomSnackBar";
  
  interface InputProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    data: any;
  }
  
  let couponService = new CouponService()
  
  const ApproveSalesDialog = (props: InputProps) => {
    const [status, setStatus] = useState('');
    const [reason, setReason] = useState("");
      
  
    const handleSubmit = () => {
        couponService.approveOrRejectComboOwner(props.data.id, {
            status: status,
            rejectReason: reason
        }).then(() => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Updated Successfully",
                type: CustomSnackbarTypes.SUCCESS,
              });
            props.setOpen(false);
            window.location.reload();
        }).catch(() => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Update Failed",
                type: CustomSnackbarTypes.ERROR,
            });
        });
      // your logic
    };
  
    return (
      <Dialog open={props.open} scroll="paper" fullWidth maxWidth="sm">
        <DialogTitle>Please fill the required details</DialogTitle>
  
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Select Status"
              select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="APPROVED">Approved</MenuItem>
              <MenuItem value="REJECTED">Rejected</MenuItem>
            </TextField>
          </FormControl>
          {
            status === 'REJECTED' && (
              <FormControl fullWidth margin="normal">
                <TextField
                  label="Enter Reason"
                  multiline
                  minRows={2}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </FormControl>
            )
          }
        </DialogContent>
  
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit}
            size="large"
          >
            Submit
          </Button>
  
          <Button
            variant="contained"
            color="error"
            onClick={() => props.setOpen(false)}
            size="large"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ApproveSalesDialog;
  